import axios from "libs/axios";
import { isWebview, handleFetchErrors, handleFailedToFetch } from "helpers";
import { AFREECATV_URL } from "constant/config";
import { ROOT_URL } from "./config";
import { toastr } from "components/toastr";
import i18next from "i18next";


export const fetchTitleBlind = async (titleNo = 0, blindId = "", close) => {

    fetch(`/${ROOT_URL}/${global.bj_id}/title/${titleNo}/blind${blindId ? ('?blind_id=' + blindId) : '' }`, {
        credentials: "include",
    })
        .then(handleFetchErrors, handleFailedToFetch)
        .then((response) => response.json())
        .then((response) => {
            close();
            toastr.success(i18next.t(response.message), {
                timeOut: 2000,
            });
        })
        .catch((error) => {
            close();
            toastr.error(error.message, {
                timeOut: 2000,
            });
        });
}

export const fetchLiveBlind = async (targetId = '', isWebViewClose = true) => {
    const url = `/${ROOT_URL}/${global.bj_id}/broadInfo/${targetId}`;
    try {
        const response = await axios.get(url);
        let target_broad_no = '';
        let target_id = targetId;
        if(response.data) {
            target_broad_no = response.data.broad_no;
            target_id = response.data.user_id;
        } 

        // AOS 웹뷰 function call 
        window.ReportBridge.reportUgcPolicy(target_id, target_broad_no);

    } catch (error) {
        
    } finally {
        if (isWebViewClose) {
            window.location.href = isWebview ? 'onlive://browser/close' : AFREECATV_URL;
        }
    }
}
